import React from 'react'
import { Loader2 } from 'lucide-react'
import FileUpload from '../app/common/FileUpload'
import type { DocumentUploadAreaProps } from './types'
import styles from '../../pages/DocumentsPage.module.css'

export const DocumentUploadArea: React.FC<DocumentUploadAreaProps> = ({
  onFilesSelected,
  uploadQueue,
  maxSize,
}) => {
  const activeUploads = uploadQueue.filter(i => i.status === 'pending' || i.status === 'uploading')

  return (
    <div className={styles.uploadArea}>
      <FileUpload
        prompt={['Drop files or click to upload']}
        processUploadedFiles={onFilesSelected}
        maxSize={maxSize}
      />
      {/* Only show actively uploading items */}
      {activeUploads.length > 0 && (
        <div className={styles.uploadingItems}>
          {activeUploads.map(item => (
            <div key={item.id} className={styles.uploadingItem}>
              <Loader2 size={12} className={styles.spinner} />
              <span>{item.file.name}</span>
            </div>
          ))}
        </div>
      )}
    </div>
  )
}

